import React from "react";

class IconPlane extends React.Component {
    render() {
        return (
            <svg
                className="icon--plane"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g
                    id="send_24px"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        transform="translate(0.000000, 2.000000)"
                        fill="currentColor"
                        fillRule="nonzero"
                    >
                        <path d="M23.9303571,1.83554377 L20.3089286,18.7480106 C20.0357143,19.9416446 19.3232143,20.2387268 18.3107143,19.6763926 L12.7928571,15.6498674 L10.1303571,18.1856764 C9.83571429,18.4774536 9.58928571,18.7214854 9.02142857,18.7214854 L9.41785714,13.1564987 L19.6446429,4.00530504 C20.0892857,3.6127321 19.5482143,3.39522546 18.9535714,3.78779841 L6.31071429,11.6710875 L0.867857143,9.98408488 C-0.316071429,9.61803714 -0.3375,8.81167109 1.11428571,8.24933687 L22.4035714,0.127320955 C23.3892857,-0.23872679 24.2517857,0.344827586 23.9303571,1.83554377 Z" />
                    </g>
                </g>
            </svg>
        );
    }
}

export default IconPlane;



// WEBPACK FOOTER //
// ./src/components/icons/IconPlane.jsx